
import { ActiveObject } from '../../Container';

export class ControlsMechanics extends ActiveObject {

    public start(): void {
        // this.burden(
        // );
    }
}
